import {
  START_LOGGED,
  IS_LOGGED,
  ERROR_LOGGED,
  START_LOGOUT,
  IS_LOGOUT,
  START_LOADING,
  END_LOADING,
  START_REGISTER,
  IS_REGISTER,
  ERROR_REGISTER,
  START_RESTORE_PASSWORD,
  IS_RESTORE_PASSWORD,
  ERROR_RESTORE_PASSWORD,
  START_RESEND_CONFIRMATION,
  IS_RESEND_CONFIRMATION,
  ERROR_RESEND_CONFIRMATION,
  START_MODIFIED_USER,
  IS_MODIFIED_USER,
  IS_MODIFIED_POINTS_USER,
  ERROR_MODIFIED_USER,
  IS_IN_SESSION,
  ISNT_IN_SESSION
} from "../actions/userActions";

const initialState = {
  user: {},
  isLogged: false,
  error: false,
  loading: false
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case START_LOADING:
      return {
        ...state,
        loading: true
      };
    case END_LOADING:
      return {
        ...state,
        loading: false
      };
    case START_LOGGED:
      return {
        ...state,
        error: false,
        loading: true
      };
    case IS_LOGGED:
      return {
        ...state,
        user: action.payload,
        isLogged: true,
        loading: false,
        error: false
      };
    case ERROR_LOGGED:
      return {
        ...state,
        error: true,
        loading: false
      };
    case START_REGISTER:
      return {
        ...state,
        error: false,
        loading: true
      };
    case IS_REGISTER:
      return {
        ...state,
        loading: false,
        error: false
      };
    case ERROR_REGISTER:
      return {
        ...state,
        error: true,
        loading: false
      };
    case START_RESTORE_PASSWORD:
      return {
        ...state,
        error: false,
        loading: true
      };
    case IS_RESTORE_PASSWORD:
      return {
        ...state,
        loading: false,
        error: false
      };
    case ERROR_RESTORE_PASSWORD:
      return {
        ...state,
        error: true,
        loading: false
      };
    case START_RESEND_CONFIRMATION:
      return {
        ...state,
        error: false,
        loading: true
      };
    case IS_RESEND_CONFIRMATION:
      return {
        ...state,
        loading: false,
        error: false
      };
    case ERROR_RESEND_CONFIRMATION:
      return {
        ...state,
        error: true,
        loading: false
      };
    case START_MODIFIED_USER:
      return {
        ...state,
        error: false,
        loading: true
      };
    case IS_MODIFIED_USER:
      return {
        ...state,
        user: action.payload,
        loading: false,
        error: false
      };
    case IS_MODIFIED_POINTS_USER:
      const copyUser = Object.assign({}, state.user);
      copyUser.points = action.payload;
      return {
        ...state,
        user: copyUser,
        loading: false,
        error: false
      };
    case ERROR_MODIFIED_USER:
      return {
        ...state,
        error: true,
        loading: false
      };
    case START_LOGOUT:
      return {
        ...state,
        loading: true
      };
    case IS_IN_SESSION:
      return {
        ...state,
        user: action.payload,
        isLogged: true
      };
    case ISNT_IN_SESSION:
      return {
        ...state,
        isLogged: false
      };
    case IS_LOGOUT:
      return {
        ...state,
        isLogged: false,
        loading: false,
        user: {}
      };
    default:
      return state;
  }
}
